import { ToolsOptionsType } from '@/pages/Onboarding/options/Tools/types';

export const TOOLS_OPTIONS: ToolsOptionsType = [
  {
    id: 'whip',
    title: 'Whip',
    subtitle: 'Sharp, swift, and always ready',
  },
  {
    id: 'chains',
    title: 'Chains',
    subtitle: 'Cold metal. Complete control',
  },
  {
    id: 'rope',
    title: 'Rope',
    subtitle: 'Soft on skin, firm on will',
  },
  {
    id: 'gag',
    title: 'Gag',
    subtitle: 'Silence is obedience',
  },
  {
    id: 'choker',
    title: 'Choker with leash',
    subtitle: 'Claimed. Stylish. Obey.',
  },
];
